import axios from "axios";
import router from "./router.js";
axios.interceptors.response.use(
  response => {
    if (response.data.msg === "lostConnection") {
      localStorage.removeItem("logined");
      localStorage.removeItem("passWord");
      router.push({ name: "index" });
    }
    return response;
  },
  error => {
    return Promise.reject(error.response.data);
    // return Promise.reject(error.response.data);
  }
);
